import { MOUSE_EVENTS, SCROLL_MULTIPLIER } from '@/pages/benefits/events/constants'

export const calculateScrollPosition = (currentX, startX, initialScrollLeft) => {
  const deltaX = currentX - startX
  const scrollDistance = deltaX * SCROLL_MULTIPLIER
  return initialScrollLeft - scrollDistance
}

export const setCursor = (element, cursorType) => {
  element.style.cursor = cursorType
}

export const addScrollEventListeners = (handleMouseMove, handleMouseUp) => {
  document.addEventListener(MOUSE_EVENTS.MOVE, handleMouseMove)
  document.addEventListener(MOUSE_EVENTS.UP, handleMouseUp)
}

export const removeScrollEventListeners = (handleMouseMove, handleMouseUp) => {
  document.removeEventListener(MOUSE_EVENTS.MOVE, handleMouseMove)
  document.removeEventListener(MOUSE_EVENTS.UP, handleMouseUp)
}

export default () => {}
